import Selector from '../selector';

export default class DataConfigManage {
  constructor(data,table) {
    // selector
    this.selector = new Selector(data);
    this.data = data;
    this.table = table;
  }

  //处理单元格或者选择区域类型的配置
  updateCellConfig(ri, ci,type,config,data){
    let configKey = ri+'-'+ci+'-key';
    if (!config) {
      config = {...data.configInit[type]}
    }
    if (data.config[configKey]) {
      data.config[configKey][type] = {...config};
    }else{
      data.config[configKey] = {};
      data.config[configKey][type] = {...config}
    }
  }

  //处理图片显示
  updateConfig(ri, ci,type,data,config,isCellConfig=true) {
    let configObj = null;
    if (isCellConfig) {
      let configKey = ri+'-'+ci+'-key';
      if (config) {
        configObj = config
      }else{
        if (data.config && data.config[configKey] && Object.keys(data.config[configKey]).length>0) {
          if (data.config[configKey][type]) {
            configObj = {...data.config[configKey][type]};
          }
        }
        if (!configObj && imgObj && imgObj.config) {
          configObj = {...imgObj.config};
        }
      }
      this.updateCellConfig(ri, ci,type,configObj,data);
    } else {
      if (config) {
        configObj = config
      }else{
        if (data.config && data.config.config && data.config.config[type]) {
          configObj = {...data.config.config[type]};
        }
      }
      if (!configObj) {
        configObj = {};
      }
      if (data.config.config) {
        data.config.config[type] = {...configObj};
      }else{
        data.config.config = {};
        data.config.config[type] = {...configObj}
      }
    }
  }

  //还原配置
  restoreConfig(ri, ci,type,data,isCellConfig=true) {
    let configObj = null;
    if (isCellConfig) {
      configObj = {...data.configInit[type]};
      this.updateCellConfig(ri, ci,type,configObj,data);
    } else {
      configObj = {...data.configInit[type]};
      if (!configObj) {
        configObj = {};
      }
      if (data.config.config) {
        data.config.config[type] = {...configObj};
      }else{
        data.config.config = {};
        data.config.config[type] = {...configObj}
      }
    }
  }
}
